import { ServerApiMapper } from '~commonInfra/utils/ServerModelHelper';
import { WebClientListResourceFetcher } from '~src/httpClient/fetchers/resourceFetchers/WebClientListResourceFetcher';

import { IResourceQuery, ResourceQuery } from '../../httpClient/resources/ResourceQuery';
import { IResult } from '../../httpClient/serverApi/types/IResponse';
import { RequestHelper } from '../../httpClient/utils/RequestHelper';
import { ResultHelper } from '../../httpClient/utils/ResultHelper';
import { WebHttpClientWithErrorToastInstance } from '../../httpClient/WebHttpClientWithErrorToast';
import { SelfServiceSchedule } from '../../schedule/serverApi/types/SelfServiceSchedule';
import { ISetSelfServiceSubscriptionsFrequencyParams, ISetSubscriptionsFormatParams, ISetSubscriptionsFrequencyParams } from '../../spacesPlatform/utils/actionParams';
import { PageOrientationServerString, PdfPageSizeServerString } from '../components/SubscriptionChangeFormatDialog';
import { DeleteSubscriptionsRequest } from '../serverApi/requests/DeleteSubscriptionsRequest';
import { GetSubscriptionsRequest } from '../serverApi/requests/GetSubscriptionsRequest';
import { ResumeSubscriptionRequest } from '../serverApi/requests/ResumeSubscriptionRequest';
import { SetSelfServiceSubscriptionsFrequencyRequest } from '../serverApi/requests/SetSelfServiceSubscriptionsFrequencyRequest';
import { SetSubscriptionsDataConditionRequest } from '../serverApi/requests/SetSubscriptionDataConditionRequest';
import { SetSubscriptionsFormatRequest } from '../serverApi/requests/SetSubscriptionsFormatRequest';
import { SetSubscriptionsFrequencyRequest } from '../serverApi/requests/SetSubscriptionsFrequencyRequest';
import { SetSubscriptionsScheduleRequest } from '../serverApi/requests/SetSubscriptionsScheduleRequest';
import { SetSubscriptionsSelfServiceScheduleRequest } from '../serverApi/requests/SetSubscriptionsSelfServiceSchedule';
import { SetSubscriptionSubjectRequest } from '../serverApi/requests/SetSubscriptionSubjectRequest';
import { SubscriptionDataConditionType } from '../serverApi/types/SubscriptionDataCondition';
import { ISubscriptionInfo } from './ISubscriptionInfo';


class SubscriptionsResource {

  private listFetcher = new WebClientListResourceFetcher(GetSubscriptionsRequest, ServerApiMapper.subscriptions);

  private getErrorNotifyingServer() {
    return WebHttpClientWithErrorToastInstance;
  }

  public all(): IResourceQuery<ISubscriptionInfo> {
    return new ResourceQuery(this.listFetcher);
  }

  public del(ids: string[]): Promise<IResult> {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new DeleteSubscriptionsRequest(idsBlock)),
      ResultHelper.combineResults);
  }

  resume(id: string): Promise<IResult> {
    return this.getErrorNotifyingServer().sendRequest(new ResumeSubscriptionRequest(id));
  }

  setSchedule(ids: string[], scheduleId: string) {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetSubscriptionsScheduleRequest(idsBlock, scheduleId)),
      ResultHelper.combineResults);
  }

  setSelfServiceSchedule(ids: string[], schedule: SelfServiceSchedule) {
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) =>
        new SetSubscriptionsSelfServiceScheduleRequest({ ids, schedule })),
      ResultHelper.combineResults);
  }

  changeSubject(id: string, subject: string): Promise<IResult> {
    return this.getErrorNotifyingServer().sendRequest(new SetSubscriptionSubjectRequest(id, subject));
  }

  changeDataCondition(ids: string[], dataConditionType: SubscriptionDataConditionType): Promise<IResult> {
    return this.getErrorNotifyingServer().sendRequest(
      new SetSubscriptionsDataConditionRequest({ ids, dataConditionType }));
  }

  changeFormat(ids: string[], attachImage: boolean, attachPdf: boolean, pageSizeOption: PdfPageSizeServerString, pageOrientation: PageOrientationServerString): Promise<IResult> {
    const params: ISetSubscriptionsFormatParams = {
      ids: ids,
      attachImage: attachImage,
      attachPdf: attachPdf,
      pageSizeOption: pageSizeOption,
      pageOrientation: pageOrientation
    };
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetSubscriptionsFormatRequest(params)),
      ResultHelper.combineResults);
  }

  changeFrequency(ids: string[], scheduleId: string, subscribeOnExtractRefresh: boolean): Promise<IResult> {
    const params: ISetSubscriptionsFrequencyParams = { ids: ids, scheduleId: scheduleId, subscribeOnExtractRefresh: subscribeOnExtractRefresh };
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetSubscriptionsFrequencyRequest(params)),
      ResultHelper.combineResults);
  }

  changeSelfServiceSubscriptionsFrequency(ids: string[], schedule: SelfServiceSchedule, subscribeOnExtractRefresh: boolean): Promise<IResult> {
    const params: ISetSelfServiceSubscriptionsFrequencyParams = { ids: ids, schedule: schedule, subscribeOnExtractRefresh: subscribeOnExtractRefresh };
    return this.getErrorNotifyingServer().sendRequests(
      RequestHelper.buildRequests(ids, (idsBlock) => new SetSelfServiceSubscriptionsFrequencyRequest(params)),
      ResultHelper.combineResults);
  }
}

export const Subscriptions = new SubscriptionsResource;
